import theme from "theme";
import { colors } from "theme/palette";

import { IFixedTable } from "components/FixedTable";
import { TableCell, TableHead, TableRow } from "components/Table";
import Text from "components/Text";

const Headers = ({
  headers,
  showDeleteCell,
}: {
  headers: IFixedTable["headers"];
  showDeleteCell?: boolean;
}) => {
  return (
    <TableHead
      sx={{ backgroundColor: colors.blue20 }}
      data-testid="table-headers"
    >
      <TableRow data-testid="table-headers-section">
        {headers.map((header) => (
          <TableCell
            key={header.key}
            sx={{
              borderRight: `1px solid ${colors.blue40}`,
              borderBottom: `1px solid ${colors.blue40}`,
              padding: theme.spacing(1.25, 2),
              width: `${header.width}px`,
              "@media print": { color: colors.black },
            }}
            data-testid="header-cell"
          >
            <Text
              variant="labelSmall"
              fontWeight="500"
              data-testid="header-column-name"
            >
              {header.label}
            </Text>
          </TableCell>
        ))}
        {showDeleteCell && (
          <TableCell
            sx={{
              borderRight: `1px solid ${colors.blue40}`,
              borderBottom: `1px solid ${colors.blue40}`,
              padding: theme.spacing(1.25, 2),
              width: theme.spacing(7),
              "@media print": { color: colors.black },
            }}
            data-testid="delete-header-cell"
          />
        )}
      </TableRow>
    </TableHead>
  );
};

export default Headers;
